// export const BASE_URL = 'http://localhost:5054/api';
// export const BASE_URL = 'https://scanwellback.phvtech.com/api';
// export const BASE_URL = 'https://crm.scanwellapps.com/api';
export const BASE_URL = 'https://scanwell.phvtech.com/api';

// export const STATIC_URL = 'http://localhost:5054';
// export const STATIC_URL = 'https://scanwellback.phvtech.com';
// export const STATIC_URL = 'https://crm.scanwellapps.com';
export const STATIC_URL = 'https://scanwell.phvtech.com';